/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Infrastructures_TitleInputs */

const en_us2_infrastructures_title = /** @type {(inputs: Infrastructures_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const en_gb2_infrastructures_title = /** @type {(inputs: Infrastructures_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

/**
* | output |
* | --- |
* | "Assets" |
*
* @param {Infrastructures_TitleInputs} inputs
* @param {{ locale?: "en-US" | "en-GB" }} options
* @returns {LocalizedString}
*/
export const infrastructures_title = /** @type {((inputs?: Infrastructures_TitleInputs, options?: { locale?: "en-US" | "en-GB" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Infrastructures_TitleInputs, { locale?: "en-US" | "en-GB" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return en_gb2_infrastructures_title(inputs)
	return en_us2_infrastructures_title(inputs)
});